import { jsx as _jsx } from "react/jsx-runtime";
import { useClassName } from '../../hooks';
import './Skeleton.scss';
/**
 * Skeleton component is used to display a loading state for the user.
 */
export const Skeleton = ({ height, width, maxHeight, maxWidth, minHeight, minWidth, borderRadius = 'xs', containerBackground = 'white', ...props }) => {
    const className = useClassName({ name: 'skeleton', prefixed: true }, height && `h-${height}`, width && `w-${width}`, minHeight && `min-h-${minHeight}`, minWidth && `min-w-${minWidth}`, maxHeight && `max-h-${maxHeight}`, maxWidth && `max-w-${maxWidth}`, borderRadius && `rounded-${borderRadius}`, containerBackground && `container-bg-${containerBackground}`);
    return _jsx("div", { "data-testid": 'skeleton', className: className, ...props });
};
